import { Injectable } from '@angular/core';
import { NgRedux, ObservableStore } from '@angular-redux/store';
import { IAppState } from '../../../../../store/model';
import { DraftFilterActionConstant, draftFilterReducer, DraftFilterState } from '../reducer/draft-filter.reducer';
import { SearchItem } from '../../../../models/search-item';
import { Aggregate } from '../../../../models/aggregate';
import { StoreReducers } from '../../../../../store/root.reducer';
import { StoreKeys } from '../../../../models/store-keys';

@Injectable({
  providedIn: 'root'
})
export class DraftFilterAction {

  private localStore: ObservableStore<DraftFilterState>;


  constructor(
    private ngRedux: NgRedux<IAppState>
  ) {
    this.localStore = this.ngRedux.configureSubStore([StoreReducers.DYNAMIC_SUB_STORES, StoreKeys.DRAFT_FILTERS], draftFilterReducer);
  }

  public addFilterStarted(): void {
    this.localStore.dispatch({
      type: DraftFilterActionConstant.ADD_FILTER_ITEMS_START
    });
  }

  public addFilterSucceeded(filterItem: SearchItem, agg: Aggregate): void {
    this.localStore.dispatch({
      type: DraftFilterActionConstant.ADD_FILTER_ITEMS_SUCCEEDED,
      payload: {
        filterItems: [filterItem],
        lastAgg: agg}
    });
  }

  public addFilterFailed(error: any) {
    this.localStore.dispatch({
      type: DraftFilterActionConstant.ADD_FILTER_ITEMS_FAILED,
      error: error
    });
  }

  public updateFilterStarted(): void {
    this.localStore.dispatch({
      type: DraftFilterActionConstant.UPDATE_FILTER_ITEMS_START
    });
  }

  public updateFilterSucceeded(filterItem: SearchItem, agg: Aggregate): void {
    this.localStore.dispatch({
      type: DraftFilterActionConstant.UPDATE_FILTER_ITEMS_SUCCEEDED,
      payload: {
        filterItems: [filterItem],
        lastAgg: agg}
    });
  }

  public updateFilterFailed(error: any) {
    this.localStore.dispatch({
      type: DraftFilterActionConstant.UPDATE_FILTER_ITEMS_FAILED,
      error: error
    });
  }

  public removeFilterStarted(): void {
    this.localStore.dispatch({
      type: DraftFilterActionConstant.REMOVE_FILTER_ITEM_STARTED
    });
  }

  public removeFilterSucceeded(filterItem: SearchItem) {
    this.localStore.dispatch({
      type: DraftFilterActionConstant.REMOVE_FILTER_ITEM_SUCCEEDED,
      payload: {
        filterItems: [filterItem],
        lastAgg: null}
    });
  }

  public removeFilterFailed(error: any) {
    this.localStore.dispatch({
      type: DraftFilterActionConstant.REMOVE_FILTER_ITEM_FAILED,
      error: error
    });
  }

  public removeFiltersAndKeepLastAgg(): void {
    this.localStore.dispatch({
      type: DraftFilterActionConstant.REMOVE_FILTERS_AND_KEEP_LAST_AGG_SUCCEEDED
    });
  }

  public removeAllFiltersSucceeded() {
    this.localStore.dispatch({
      type: DraftFilterActionConstant.REMOVE_ALL_FILTER_ITEMS_SUCCEEDED
    });
  }


}
